const baseUrl = process.env.REACT_APP_baseUrl;
const SocketUrl=process.env.REACT_APP_SOCKET_IO_URL;
export { baseUrl,SocketUrl };
